import React, { FC, useMemo } from 'react';

import { Button as OrbButton } from '@yandex-360/orb-components/dist/components/Button';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { SvgImage } from '../../../../../../shared/components';
import { useToggleFullscreen } from '../../hooks/use-toggle-fullscreen';
import { selectIsFullscreen } from '../../slice';
import styles from './styles.css';

type Props = {
    isPinned?: boolean;
    videoElementRef?: HTMLVideoElement | null;
    className?: string;
};

export const FullscreenButton: FC<Props> = ({ isPinned = false, videoElementRef, className }) => {
    const { toggleFullscreen } = useToggleFullscreen(videoElementRef);
    const isFullscreen = useSelector(selectIsFullscreen);
    const fullscreenButtonIcon = useMemo(() => {
        return <SvgImage imageName={isFullscreen ? 'fullscreenOffOutline' : 'fullscreenOnOutline'} />;
    }, [isFullscreen]);

    return (
        <OrbButton
            view="neutral"
            size="md"
            className={cn(
                styles.fullscreenButton,
                {
                    [styles.fullscreenButtonPinned]: isPinned,
                },
                className
            )}
            onPress={toggleFullscreen}
            icon={fullscreenButtonIcon}
        />
    );
};
